import { Divider, Dropdown, Menu, MenuButton, MenuItem } from '@mui/joy';
import { FC, JSX, MouseEvent, useState } from 'react';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import IconButton from '@mui/joy/IconButton';
import { useNavigate } from 'react-router';
import { useToast } from '@consolidocs-ui/utils';
import { AlertModal } from '@consolidocs-ui/components';
import { useDeleteContractMutation } from '@consolidocs-ui/data-access/ContractApi';

type Props = {
  contractId: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
};

export const RowMenu: FC<Props> = ({ contractId, onClick }): JSX.Element => {
  const navigate = useNavigate();
  const [triggerToast] = useToast();
  const [deleteContract, { isLoading: isDeleting }] =
    useDeleteContractMutation();
  const [openDeleteModal, setDeleteModal] = useState(false);

  const handleDeleteContract = async () => {
    try {
      await deleteContract(contractId).unwrap();
      triggerToast({
        message: 'Contract Deleted Successfully',
        type: 'success',
      });
    } catch (err: unknown) {
      triggerToast({ message: 'Error Deleting Contract', type: 'danger' });
    }
    setDeleteModal(false);
  };

  return (
    <>
      <AlertModal
        alertAction={handleDeleteContract}
        alertActionText="Delete"
        alertCancelText="Cancel"
        alertMessage="Are you sure you want to delete this contract?"
        alertTitle="Delete Contract"
        isLoading={isDeleting}
        open={openDeleteModal}
        setOpen={setDeleteModal}
      />
      <Dropdown>
        <MenuButton
          slots={{ root: IconButton }}
          slotProps={{
            root: { variant: 'plain', color: 'neutral', size: 'sm' },
          }}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(e);
          }}
        >
          <MoreHorizRoundedIcon />
        </MenuButton>
        <Menu size="sm" sx={{ minWidth: 140 }}>
          <MenuItem onClick={() => navigate(`/contracts/edit/${contractId}`)}>
            Edit
          </MenuItem>
          <Divider />
          <MenuItem
            color="danger"
            onClick={(e) => {
              e.stopPropagation();
              setDeleteModal(true);
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </Dropdown>
    </>
  );
};
